import styled, { css } from 'styled-components';

import colors from 'app/styles/theme/colors';

const { gray, green } = colors.designSystem;

export const Footer = styled.div<{ $sideBySide?: boolean }>`
  display: flex;
  justify-content: ${({ $sideBySide }) => ($sideBySide ? 'space-between' : 'flex-end')};
  gap: 12px;
`;

const dialogButton = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 7px;
  border: 1px solid transparent;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  @media (prefers-reduced-motion: no-preference) {
    transition: 120ms ease;
  }
`;

export const SecondaryButton = styled.button`
  ${dialogButton}
  background: transparent;
  color: ${gray[800]};
  border-color: ${gray[400]};

  &:hover,
  &:focus-visible {
    background-color: ${gray[100]};
  }
`;

export const PrimaryButton = styled.button`
  ${dialogButton}
  background-color: ${green[500]};
  color: ${gray[0]};

  &:hover,
  &:focus-visible {
    background-color: ${colors.green.senary};
  }
`;
